import { z } from "zod";

export const adminConsentRecordDecisions = ["accepted", "refused"] as const;
export const AdminConsentRecordDecisionSchema = z.enum(adminConsentRecordDecisions);
export type AdminConsentRecordDecision = z.infer<typeof AdminConsentRecordDecisionSchema>;

export const adminConsentRecordSources = ["consent_gate", "preferences"] as const;
export const AdminConsentRecordSourceSchema = z.enum(adminConsentRecordSources);
export type AdminConsentRecordSource = z.infer<typeof AdminConsentRecordSourceSchema>;

export const adminConsentRecordTypes = ["document", "opt_in"] as const;
export const AdminConsentRecordTypeSchema = z.enum(adminConsentRecordTypes);
export type AdminConsentRecordType = z.infer<typeof AdminConsentRecordTypeSchema>;

type TranslationDescriptor = {
    fallback: string;
    key: string;
};

type DecisionDescriptor = TranslationDescriptor & {
    variant: "tags-green" | "tags-red";
};

type TypeDescriptor = TranslationDescriptor & {
    variant: "tags-green" | "tags-red";
};

const decisionDescriptors: Record<AdminConsentRecordDecision, DecisionDescriptor> = {
    accepted: {
        key: "settings.consent.records.accepted",
        fallback: "Accepted",
        variant: "tags-green",
    },
    refused: {
        key: "settings.consent.records.refused",
        fallback: "Refused",
        variant: "tags-red",
    },
};

const sourceDescriptors: Record<AdminConsentRecordSource, TranslationDescriptor> = {
    consent_gate: {
        key: "settings.consent.records.source_consent_gate",
        fallback: "Consent gate",
    },
    preferences: {
        key: "settings.consent.records.source_preferences",
        fallback: "User preferences",
    },
};

const typeDescriptors: Record<AdminConsentRecordType, TypeDescriptor> = {
    document: {
        key: "settings.consent.records.type_document",
        fallback: "Contractual",
        variant: "tags-red",
    },
    opt_in: {
        key: "settings.consent.records.type_opt_in",
        fallback: "Optional",
        variant: "tags-green",
    },
};

export const getAdminConsentRecordDecisionDescriptor = (decision: AdminConsentRecordDecision): DecisionDescriptor =>
    decisionDescriptors[decision];

export const getAdminConsentRecordSourceDescriptor = (source: AdminConsentRecordSource): TranslationDescriptor =>
    sourceDescriptors[source];

export const getAdminConsentRecordTypeDescriptor = (type: AdminConsentRecordType): TypeDescriptor =>
    typeDescriptors[type];
